import {
  backupControlsKey,
  CONTROLS_BACKUP_KEY,
  loadLastPadProfile,
  saveLastPadProfile,
} from './controllerCache.js';
import { fetchProfileControls, pushProfileControlEntry } from './profileApi.js';

let syncEnabled = false;
let profileEmail = null;
let pullPromise = null;
let pushTimer = null;
const pendingKeys = new Set();

export function isProfileSyncEnabled() {
  return syncEnabled;
}

export function getProfileEmail() {
  return profileEmail;
}

function readLocalControlsMap() {
  try {
    const raw = localStorage.getItem(CONTROLS_BACKUP_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeLocalControlsMap(data) {
  try {
    localStorage.setItem(CONTROLS_BACKUP_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

function mergeRemoteIntoLocal(remoteControls) {
  if (!remoteControls || typeof remoteControls !== 'object') return 0;
  const local = readLocalControlsMap();
  let merged = 0;
  for (const [key, controls] of Object.entries(remoteControls)) {
    if (!controls || typeof controls !== 'object') continue;
    local[key] = controls;
    merged += 1;
  }
  if (merged) writeLocalControlsMap(local);
  return merged;
}

export function pullProfileControls() {
  if (pullPromise) return pullPromise;

  pullPromise = (async () => {
    try {
      const data = await fetchProfileControls();
      if (data.syncEnabled === false) {
        syncEnabled = false;
        profileEmail = null;
        return { ok: true, syncEnabled: false, merged: 0 };
      }
      syncEnabled = true;
      profileEmail = data.email || (data.legacy ? 'legacy' : null);
      if (data.lastPadProfile) saveLastPadProfile(data.lastPadProfile);
      const merged = mergeRemoteIntoLocal(data.controls);
      return { ok: true, syncEnabled: true, merged, email: profileEmail };
    } catch (err) {
      if (err?.status === 401) {
        syncEnabled = false;
        profileEmail = null;
        return { ok: false, syncEnabled: false, reason: 'unauthenticated' };
      }
      return { ok: false, syncEnabled: false, reason: err?.message || 'network' };
    } finally {
      pullPromise = null;
    }
  })();

  return pullPromise;
}

function flushPendingProfilePush() {
  pushTimer = null;
  if (!syncEnabled || !pendingKeys.size) return;

  const keys = [...pendingKeys];
  pendingKeys.clear();
  const local = readLocalControlsMap();
  const lastPadProfile = loadLastPadProfile();

  void (async () => {
    for (const key of keys) {
      const controls = local[key];
      if (!controls) continue;
      const sep = key.indexOf(':');
      if (sep <= 0) continue;
      const systemKey = key.slice(0, sep);
      const padProfile = key.slice(sep + 1);
      try {
        await pushProfileControlEntry(systemKey, padProfile, controls, lastPadProfile || undefined);
      } catch (err) {
        console.warn('[profile] Falha ao guardar controlos no servidor:', key, err);
        pendingKeys.add(key);
      }
    }
  })();
}

export function scheduleProfileControlsPush(systemKey, padProfile) {
  if (!syncEnabled) return;
  pendingKeys.add(backupControlsKey(systemKey, padProfile));
  if (pushTimer) clearTimeout(pushTimer);
  pushTimer = window.setTimeout(flushPendingProfilePush, 1500);
}

export function flushProfileControlsPush() {
  if (pushTimer) {
    clearTimeout(pushTimer);
    pushTimer = null;
  }
  flushPendingProfilePush();
}
